import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Button } from 'antd';
import styles from './UserTariffSettingsModal.styles';
import { getIsVisibleModal, closeModal } from '../../../redux/store/ui/common';
import DrawerModal from '../../shared/DrawerModal';
import { useIntl } from 'react-intl';
import {
  selectSelectedUser,
  updateUser,
} from '../../../redux/store/userData/users';

const UserTariffSettingsModal: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectSelectedUser);
  const [maxPartners, setMaxPartners] = useState(selectedUser?.maxPartners);

  const visible = useSelector(getIsVisibleModal('TariffSettingsModal'));

  const handleCancel = () => {
    dispatch(closeModal('TariffSettingsModal'));
  };

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    if (selectedUser) {
      dispatch(
        updateUser(selectedUser.id, {
          maxPartners,
        })
      );
    }
    handleCancel();
  };

  useEffect(() => {
    if (visible) {
      setMaxPartners(selectedUser?.maxPartners || '');
    }
  }, [visible]);

  return (
    <>
      <DrawerModal visible={visible} onClose={handleCancel}>
        <div className="user-Tariff-settings-contents">
          <div className="user-Tariff-settings-title">
            {intl.formatMessage({
              id: `fleetadmin.users.info.tariff.maxparteners.update`,
            })}
          </div>
          <div className="user-Tariff-settings-input-container">
            <Input
              value={maxPartners}
              placeholder={intl.formatMessage({
                id: `fleetadmin.users.info.Tariff.submissions`,
              })}
              onChange={(e) => setMaxPartners(e.target.value)}
              style={{ marginRight: 12 }}
            />
          </div>
          <div className="button-container">
            <Button className="submit-button" onClick={handleOnSubmit}>
              {intl.formatMessage({
                id: `fleetadmin.admins.info.update`,
              })}
            </Button>
            <Button className="cancel-button" onClick={handleCancel}>
              {intl.formatMessage({
                id: `fleetadmin.admins.info.cancel`,
              })}
            </Button>
          </div>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UserTariffSettingsModal;
